import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import {
    CHAT_CHANNEL_CREATE,
    CHAT_CHANNEL_CREATE_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.chat,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
});

const mapDispatchToProps = dispatch => ({
    onSubmit: (title, language) => {
        const payload = agent.Chats.createChannel(title, language);
        dispatch({ type: CHAT_CHANNEL_CREATE, payload })
    },
    onUnload: () =>
        dispatch({ type: CHAT_CHANNEL_CREATE_UNLOADED })
});

class ChannelAdd extends React.Component {
    constructor() {
        super();
        this.state = {
            title: '',
            language: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (title, language) => ev => {
            ev.preventDefault();
            this.props.onSubmit(title, language);
        }
    }
    componentWillMount(props) {
        if (this.props.currentUser) {
            Object.assign(this.state, {
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        const title = this.state.title;
        const language = this.state.language;
        const inProgress = this.props.inProgress
        return (
            <div class='pane'>
                <Link className="crumb" to="/channels">&laquo; back to chat channels</Link>
                <h1>Add channel</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(title, language)}>
                    <fieldset className="form">
                        <strong>Title</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Title"
                                value={title}
                                onChange={this.updateState('title')} />
                        </fieldset>
                        <strong>Language</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="en"
                                value={language}
                                onChange={this.updateState('language')} />
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Add
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChannelAdd);



// WEBPACK FOOTER //
// ./src/components/ChannelAdd.js